import { request } from '@utils/request/request';
import { RequestMethod } from '@utils/request/request.type';

export interface TicketDownloadStatus {
  isAvailable: boolean;
  availableFrom: number | null;
}

export const getTicketDownloadStatus = async (token: string): Promise<TicketDownloadStatus> => {
  const url = `${import.meta.env.VITE_MONOLITH_HOST}/ticket/${token}/download-status`;
  return request({ url, method: RequestMethod.GET });
};
